export const N8N_URL = 'https://bemol.app.n8n.cloud/webhook/53a44861-2d1c-4741-a69f-9fe87a29fdfe';
// export const N8N_URL = 'https://bemol.app.n8n.cloud/webhook-test/53a44861-2d1c-4741-a69f-9fe87a29fdfe';

export const IMAGE_WEBHOOK_URL = 'https://bemol.app.n8n.cloud/webhook/ocr-documento';
// export const IMAGE_WEBHOOK_URL = 'https://bemol.app.n8n.cloud/webhook-test/ocr-documento';
